<template>
  <div class="widgetContainer">
    <hooper :centerMode="true" @slide="onSwipe" :itemsToShow="size">
      <slide v-for="(mask, indx) in masks" :key="indx" :index="indx">
        <div class="widget" v-if="currentMask && currentMask.name === mask.name" :id="mask.name"
             v-touch:tap="tapHandler" v-touch:touchhold="tapHandler">
          <img :src="mask.icon" alt=""/>
        </div >
        <div class="widget" :id="mask.name" v-else>
          <img :src="mask.icon" alt=""/>
        </div >
      </slide>
    </hooper>
    <Textures :mask="currentMask"/>
  </div>

</template>

<script>

import {store} from "@/store/store";
import Textures from "./Textures";
import {Hooper, Slide} from 'hooper';
import 'hooper/dist/hooper.css';
import {mapState, mapActions} from "vuex";


export default {
  name: 'widgetContainer',
  props: {
    tapHandler: Function
  },
  components: {
    Textures,
    Hooper,
    Slide,
  },
  data() {
    return {
      masks: this.$store.state.masks,
      size: 13
    }
  },
  methods: {
    ...mapActions(['changeCurrentMask']),
    sizeBox() {
      this.size = Math.floor(document.querySelector('body').offsetWidth / 90, 1)
    },
    onSwipe() {

      if (threestuff) {
        threestuff.faceObjects.forEach(function (faceObject) {
          faceObject.children = [];
        });
      }

      setTimeout(() => {
        const firstElement = document.querySelector('.is-current');
        this.changeCurrentMask(this.masks.find(mask => mask.name === firstElement.children[0].id));

        let maskObject = this.currentMask.object ? this.currentMask.object : this.currentMask.name.toLowerCase();

        if (this.currentMask.textures[0]){
          if (this.currentMask.textures[0].url_object.includes('png')) {
            load_mask(maskObject, this.currentMask.textures[0].url_object);
          } else {
            load_mask(this.currentMask.textures[0].url_object);
          }
        }
      }, 800)

    },
  },
  mounted() {
    setTimeout(() => {
      this.onSwipe()
    }, 600)

  },
  created() {
    this.sizeBox()

  },
  updated() {
    this.sizeBox()

  },
  computed: {
    ...mapState([
      "currentMask",
    ])
  }
}

</script>

<style>
.widgetContainer {
  width: 100vw;
  position: absolute;
  z-index: 1;
  /*height: 100%;*/
  padding-bottom: env(safe-area-inset-bottom)
}

.hooper {
  height: 100px;
  display: flex;
  align-items: center;
}

.hooper-slide {
  display: flex;
  justify-content: center;
  align-items: center;
  /*height: 75px!important;*/
  /*width: 75px!important;*/
  border-radius: 50%;
  /*border:2px solid transparent;*/
}

.hooper-track {
  margin: initial;
}

.hooper-list {
  /*width: initial;*/
  height: initial;
}

/*section.hooper {*/
/*  height: 100%;*/
/*  outline: none;*/
/*}*/

.hooper img {
  transition: .3s;
  filter: invert(1);
  width: 100%;
}

.hooper .is-current img {
  filter: invert(1) sepia(1) hue-rotate(88deg) saturate(71);
  width: 90%;
}

.hooper .is-current .widget {
  padding: 0;
}

.hooper .widget {
  /*background: #fff;*/
  border: 2px solid #00d6ff;
  padding: 5px;
}

.widget {
  width: 75px;
  height: 75px;
  border-radius: 50%;
  outline: none;
  background: #47474796;
  display: flex;
  justify-content: center;
  align-items: center;

}
</style>
